import React from 'react';
import useT from '../../utils/Translations/useT';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import GroupByModel from '../../../../model/GroupByModel';
import SelectBoxFilter from './SelectBoxFilter';
const GroupPeopleBySelector = props => {
    const t = useT();
    const { options } = useEnumerableModel(GroupByModel);
    const title = t('Group by');
    return (<SelectBoxFilter name="groupBy" options={options} title={title} {...props}/>);
};
export default GroupPeopleBySelector;
